import * as types from './actionTypes';

export function contractsSet(contracts: any, isUserAdmin?: boolean) {
  return { type: types.CONTRACTS_SET, contracts, isUserAdmin };
}
